'use client';

import { Pagination } from 'antd';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { FC, useCallback } from 'react';
import type { PaginationMeta } from './BlogsPage.props';

interface PaginationControlsProps {
  meta: PaginationMeta;
}

const PaginationControls: FC<PaginationControlsProps> = ({ meta }) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleOnPageChange = useCallback(
    (page: number, pageSize: number = 10) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set('page', page.toString());
      params.set('pageSize', pageSize.toString());
      router.push(`${pathname}?${params.toString()}`);
    },
    [router, pathname, searchParams],
  );

  return (
    <Pagination
      onChange={handleOnPageChange}
      pageSize={meta?.pageSize}
      total={meta?.total ?? 0}
      current={meta?.page || 1}
      responsive
    />
  );
};

export { PaginationControls };
